/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_No_Date_SetInputs */

const en_admin_categories_no_date_set = /** @type {(inputs: Admin_Categories_No_Date_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No date set`)
};

const de_admin_categories_no_date_set = /** @type {(inputs: Admin_Categories_No_Date_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Datum gesetzt`)
};

/**
* | output |
* | --- |
* | "No date set" |
*
* @param {Admin_Categories_No_Date_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_categories_no_date_set = /** @type {((inputs?: Admin_Categories_No_Date_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_No_Date_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_categories_no_date_set(inputs)
	return en_admin_categories_no_date_set(inputs)
});